import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "tss-react/mui";
import { CircularProgress } from "@mui/material";
import Button from "../CustomButtons/Button";
import { Check, Clear } from "@mui/icons-material";

const style = {
  progressIcon: {
    marginRight: "8px",
    color: "#ffffff",
  },
};

function SpecialButton({ ...props }) {
  const { classes } = props;

  let buttonIcon = props.hasError ? <Clear className={classes.icons} /> : <Check className={classes.icons} />;
  let buttonColor = props.buttonColor ? props.buttonColor : "default";
  let buttonColorDisabled = props.buttonColorDisabled ? props.buttonColorDisabled : buttonColor;

  return props.busyFlag ? (
    <Button className={classes.marginRight} color={buttonColorDisabled} disabled>
      <CircularProgress className={classes.progressIcon} size={18} /> {props.buttonTextDisabled}
    </Button>
  ) : (
    <Button
      className={classes.marginRight}
      color={buttonColor}
      disabled={props.disabled}
      onClick={props.onClick}
      type={props.type}
    >
      {buttonIcon} {props.buttonText}
    </Button>
  );
}

SpecialButton.propTypes = {
  classes: PropTypes.object,
  busyFlag: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  hasError: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  buttonText: PropTypes.string,
  buttonTextDisabled: PropTypes.string,
  buttonColor: PropTypes.string,
  buttonColorDisabled: PropTypes.string,
};

SpecialButton.defaultProps = {
  busyFlag: false,
  hasError: false,
  disabled: false,
  buttonText: "Click me",
  buttonTextDisabled: "Busy",
  buttonColor: "primary", // ["primary","info","success","warning","danger","rose","white","twitter","facebook","google","linkedin","pinterest","youtube","tumblr","github","behance","dribbble","reddit","transparent"]
  //buttonColorDisabled: "primary",
};

export default withStyles(SpecialButton, style);
